import { PrismaClient } from "@prisma/client";

// Prevent PrismaClient from running in the browser
// if (typeof window !== "undefined") {
//   throw new Error(
//     "PrismaClient is unable to run in the browser. Please use API routes or server-side code."
//   );
// }

const prismaClientSingleton = () => {
	return new PrismaClient();
};

declare global {
	var prisma: undefined | ReturnType<typeof prismaClientSingleton>;
}

// biome-ignore lint/suspicious/noRedeclare: <explanation>
const prisma = typeof window === "undefined" ? globalThis.prisma ?? prismaClientSingleton() : null as unknown as PrismaClient;

if (process.env.NODE_ENV !== "production") {
	globalThis.prisma = prisma;
}

export { prisma as db };
